<template>
  <li class="flex flex-col gap-1.5 rounded-xl border border-border bg-glass-solid px-3 py-2.5" data-test="comando-attivo">
    <div class="flex items-start justify-between gap-2">
      <b class="inline-flex min-w-0 items-center gap-1.5 text-sm text-text-primary">
        <i :class="ICONE_TIPO[riga.tipo]" class="shrink-0 text-text-accent" aria-hidden="true" />
        <span class="truncate">{{ etichettaComando(riga, t) }}</span>
      </b>
      <StatusPill :stato="STATO_PILLOLA_ESITO[riga.esito]" :label="t(`comandi.esiti.complessivo.${riga.esito}`)" size="sm" />
    </div>
    <p class="flex flex-wrap items-center gap-x-2 text-xs text-text-secondary">
      <span>{{ etichettaMittente(riga) }}</span>
      <span aria-hidden="true">·</span>
      <time :datetime="riga.creato_il" class="tabular-nums">{{ formatDateTime(riga.creato_il, "ora") }}</time>
    </p>
    <p class="text-xs text-text-muted tabular-nums" data-test="comando-attivo-tracker">
      {{ t("layout.comandi.tracker_riusciti", { riusciti: riga.destinatari.riuscito, totale: riga.destinatari.totale }) }}
      <span v-if="riga.destinatari.in_attesa > 0">· {{ t("layout.comandi.in_attesa", { n: riga.destinatari.in_attesa }) }}</span>
    </p>
  </li>
</template>

<script setup lang="ts">
// Una riga del pannello «Comandi manuali attivi»: tipo (con l'angolo), esito, chi l'ha mandato, a che ora e quanti tracker hanno risposto.
import { useI18n } from "vue-i18n";
import { ICONE_TIPO, STATO_PILLOLA_ESITO, etichettaComando, etichettaMittente } from "~/utils/logComandi";
import type { RigaLogComando } from "~~/shared/data-model/log_comandi";

defineProps<{ riga: RigaLogComando }>();
const { t } = useI18n();
</script>
